"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _coreSc = require("@smooth-ui/core-sc");

var LinkList = _coreSc.styled.ul.withConfig({
  displayName: "NavLinkList__LinkList",
  componentId: "sc-8luyjg-0"
})(["margin:0;padding:0;display:flex;flex-direction:column;align-items:center;", ""], (0, _coreSc.up)('md', (0, _coreSc.css)(["flex-direction:row;align-items:flex-start;"])));

var _default = LinkList;
exports["default"] = _default;